/* eslint-disable class-methods-use-this */
/**
 * @flow
 * @format
 */

const PREFIX = 'sideNav- ';

class SideNavManager {
  sideNavExpanded: boolean;

  constructor() {
    this.sideNavExpanded = false;
    if (!global.callbacks) global.callbacks = {};
  }

  subscribe(id: string, cb: (isExpanded: boolean) => void): void {
    const key = `${PREFIX}${id}`;
    global.callbacks[key] = { callbackFn: cb };
  }

  unsubscribe(id: string): void {
    const key = `${PREFIX}${id}`;
    delete global.callbacks[key];
  }

  sideNavToggled(isExpanded: boolean): void {
    if (this.sideNavExpanded !== isExpanded) {
      this.sideNavExpanded = isExpanded;
      const callbackKeys = Object.keys(global.callbacks).filter((key) => key.startsWith(PREFIX));
      if (callbackKeys.length > 0) {
        callbackKeys
          .forEach((key: string) => {
            if (
              global.callbacks
            && global.callbacks[key]
            && global.callbacks[key].callbackFn
            ) {
              global.callbacks[key].callbackFn(isExpanded);
            }
          });
      }
    }
  }
}

const sideNavManager: SideNavManager = new SideNavManager();

export default sideNavManager;
